import ProgressiveImage from '@components/progressive-image/ProgressiveImage';
import './ImageFigure.scss';

const ImageFigure = (props) => (
  <div className='justify-content-center'>
    <ProgressiveImage style={props.style} localPath={props.src} alt={props.alt ? props.alt : ''} hasAvif hasWebp />
    <figcaption>{props.caption}</figcaption>
  </div>
);

export default ImageFigure;
